<template>
  <v-container fluid class="ai-page">
    <v-card class="ai-panel" elevation="0">
      <div class="ai-panel__head">
        <div class="ai-panel__title">
          <v-icon>mdi-domain</v-icon>
          Empresas
          <span class="ai-count">{{ tabela.conteudo.length }}</span>
        </div>
        <div class="ai-panel__spacer"></div>
        <v-text-field
          v-model="tabela.busca"
          append-icon="mdi-magnify"
          label="Procurar"
          single-line
          hide-details
          dense
          outlined
          class="ai-search"
        ></v-text-field>
        <v-btn color="primary" depressed @click="dialogoEmpresa = true">
          <v-icon left>mdi-plus</v-icon>Cadastrar
        </v-btn>
      </div>

      <v-data-table
        :search="tabela.busca"
        :headers="tabela.cabecalho"
        :items="tabela.conteudo"
        sort-by="nome"
        class="ai-datatable"
        :footer-props="{ 'items-per-page-text': 'Linhas por página', 'items-per-page-all-text': 'Tudo' }"
      >
        <template v-slot:[`item.situacao`]="{ item }">
          <span class="ai-status" :class="item.situacao == 'ATIVO' ? 'success--text' : 'error--text'">
            <v-icon x-small :color="item.situacao == 'ATIVO' ? 'success' : 'error'">mdi-circle</v-icon>
            {{ item.situacao == 'ATIVO' ? 'Ativo' : 'Inativo' }}
          </span>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="editItem(item)"><v-icon color="info">mdi-pencil</v-icon></v-btn>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="deleteItem(item)"><v-icon color="error">mdi-delete</v-icon></v-btn>
            </template>
            <span>Excluir</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <div class="py-6 text--secondary">
            <v-icon size="42" color="grey lighten-1">mdi-domain-off</v-icon>
            <div class="mt-2">Nenhuma empresa cadastrada</div>
            <v-btn small text color="primary" class="mt-2" @click="carregaDados">Recarregar</v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialogoEmpresa" persistent max-width="900px" class="ai-dialog">
      <v-card>
        <v-card-title><v-icon>mdi-domain</v-icon>{{ formTitle }}</v-card-title>
        <v-card-text class="ai-dialog-body">
          <v-row>
            <v-col cols="12" md="9">
              <v-text-field label="Nome*" outlined dense hide-details v-model="editedItem.nome"></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field label="CNPJ*" v-mask="'##.###.###/####-##'" outlined dense hide-details v-model="editedItem.cnpj"></v-text-field>
            </v-col>
            <v-col cols="12" md="8">
              <v-text-field label="Endereço*" outlined dense hide-details v-model="editedItem.endereco"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field label="Telefone*" v-mask="'(##) #####-####'" outlined dense hide-details v-model="editedItem.telefone"></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field label="Canal WebSocket*" outlined dense hide-details v-model="editedItem.canalWS" prefix="ws-"></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-select label="Alias*" outlined dense hide-details v-model="editedItem.clientAlias" :items="aliases" item-text="text" item-value="value"></v-select>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field label="Url TarifasPf" outlined dense hide-details v-model="editedItem.urlTarifasPf"></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field label="Url TarifasPj" outlined dense hide-details v-model="editedItem.urlTarifasPj"></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field label="Url Avisos" outlined dense hide-details v-model="editedItem.urlAvisos"></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field label="Url Resolucoes" outlined dense hide-details v-model="editedItem.urlResolucoes"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click="dialogoEmpresa = false">Fechar</v-btn>
          <v-btn depressed color="primary" @click="salvarEmpresa">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Snackbar ref=chamaSnackbar />
    <loading :active.sync="isLoading" :can-cancel="true" color="#038b8b" :is-full-page="fullPage"></loading>
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    components: { Snackbar, Loading, },
    data: () => ({
      isLoading: false,
      fullPage: true,
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Nome', align: 'start', value: 'nome', },
          { text: 'CNPJ', value: 'cnpj' },
          { text: 'Telefone', value: 'telefone' },
          { text: 'WS', value: 'canalWS' },
          { text: 'Ações', value: 'action', sortable: false },
        ],
        conteudo: [],
      },
      dialogoEmpresa: false,
      editedIndex: -1,
      editedItem: {
        nome: '',
        cnpj: '',
        endereco: '',
        telefone: '',
        urlTarifasPf: '',
        urlTarifasPj: '',
        urlAvisos: '',
        urlResolucoes: '',
        canalWS: '',
        clientAlias: 'paciente',
      },
      defaultItem: {
        nome: '',
        cnpj: '',
        endereco: '',
        telefone: '',
        urlTarifasPf: '',
        urlTarifasPj: '',
        urlAvisos: '',
        urlResolucoes: '',
        canalWS: '',
        clientAlias: 'paciente',
      },
      situacoes: [
        { text: 'Ativo', value: 'ATIVO' },
        { text: 'Inativo', value: 'INATIVO' },
      ],
      segmentos: [
        { text: 'Studio', value: 'STUDIO' },
      ],
      aliases: [
        { text: 'Paciente', value: 'paciente' },
      ],
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitle () {
        return this.editedIndex === -1 ? 'Adicionar nova empresa' : 'Editar empresa'
      },
    }),

    watch: {
      dialogoEmpresa(val) {
        if (val == false) {
          setTimeout(() => {
            this.editedIndex = -1
            this.editedItem = Object.assign({}, this.defaultItem)
          }, 300);
        }
      }
    },

    mounted() {
      this.carregaDados()
    },

    methods: {
      async carregaDados () {
        this.isLoading = true
        await axios.get(baseApiUrl + 'Empresas?filter={"order":"nome ASC"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.tabela.conteudo = response.data
            this.isLoading = false
          }
        })
      },

      editItem (item) {
        this.isLoading = true
        this.editedIndex = this.tabela.conteudo.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogoEmpresa = true
        this.isLoading = false
      },

      async salvarEmpresa() {
        var vm = this;
        if (this.editedItem.nome || this.editedItem.cnpj || this.editedItem.endereco || this.editedItem.telefone || this.editedItem.canalWS) {
          this.isLoading = true
          await axios.post(baseApiUrl + 'Empresas/replaceOrCreate?access_token=' + sessionStorage.getItem('accToken'), this.editedItem)
          .then(response => {
            if (response.data) {
              this.isLoading = false
              this.dialogoEmpresa = false
              vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "SUCESSO")
              this.carregaDados()
            }
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("#FEC8C8", "Erro ao realizar operação", "DESCULPE")
          })
        } else {
          vm.$refs.chamaSnackbar.snack("F9A825", "Preencha os campos para prosseguir", "ATENÇÃO")
        }
      },

      async deleteItem(item) {
        var r = confirm('Realmente deseja EXCLUIR a empresa ' + item.nome + '?')
        if (r == true) {
          await axios.delete(baseApiUrl + 'Empresas/' + item.id + '?access_token=' + sessionStorage.getItem('accToken'))
          .then(() => {
            var vm = this;
            vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "SUCESSO")
            this.carregaDados()
          })
        }
      },
    },
  }
</script>

<style scoped>
</style>
